import { structureTreeTableService } from '../services/structure/structure-treetable.service.js'

export const usePhysicalStructureStore = defineStore('physical-structure', {
  state: () => ({
    /**
     * Tree table nodes data
     */
    nodeTree: [],
    /**
     * Current Working
     */
    workingNode: null,
    /**
     * Current Node Info Parent
     */
    nodeInfo: null,

    /**
     * Data to be searched
     */
    filterText: '',
    /**
     * Valid address flag to control validation field
     */
    isValidAddress: false,
    /**
     * Track if the `type` field has a validation error
     */
    validationErrors: {
      type: false,
      name: false,
      description: false,
    },
  }),
  getters: {
    isValidBusinessUnit: ({ workingNode }) => {
      if (!workingNode) {
        return false
      }

      const data = workingNode.data

      return !!data.name
    },

    isValidSite: ({ workingNode, isValidAddress }) => {
      if (!workingNode || !isValidAddress)
        return false

      const { operationType, timezone, nameLang } = workingNode.data || {}

      return (
        !!nameLang // Ensure name is valid and has no validation errors
        && !!operationType // Operation Type must be present
        && !!timezone
      )
    },

    isValidArea: ({ workingNode }) => {
      if (!workingNode)
        return false

      const { businessArea, nameLang } = workingNode.data || {}

      return (
        !!nameLang // Ensure name is valid and has no validation errors
        && !!businessArea // Business Area must be present
      )
    },

    isValidRoute: ({ workingNode, validationErrors }) => {
      if (!workingNode)
        return false

      const { description, responsible, nameLang } = workingNode.data || {}

      return (
        !!nameLang
        && !!description
        && !validationErrors.description
        && (!!responsible || responsible === null) // Responsible must be present or null
      )
    },

    getNodeInfo: ({ nodeInfo }) => {
      return nodeInfo
    },
    getWorkingNode: ({ workingNode }) => {
      return workingNode
    },
    getWorkingNodeData: ({ workingNode }) => {
      return workingNode.data
    },
    getWorkingNodeParent: ({ workingNode }) => {
      return workingNode.parent
    },

    /**
     * Get the hierarchy for a macroProcess node.
     * @returns {string} - The hierarchy for the node.
     */
    getBusinessUnitName: (state) => {
      return state.nodeInfo.hierarchy[0]
    },

    getBusinessSiteName: (state) => {
      return state.nodeInfo.hierarchy[2]
    },

    /**
     * Returns the filtered tree data based on filterText.
     *
     * @returns {Array} - The filtered tree data.
     */
    filteredTreeData(state) {
      if (!state.filterText) {
        return state.nodeTree // Return original treeData if no filter text is provided
      }

      return structureTreeTableService.filterTreeData(
        state.nodeTree,
        'name',
        state.filterText,
      )
    },
  },
  actions: {
    /**
     * Add New Business Unit to the Level 1 In the tree
     */
    addBusinessUnit(businessUnit) {
      this.nodeTree.push(businessUnit)
    },
    /**
     * Clear Business Unit working Node
     */
    clearWorkingNode() {
      this.workingNode = null
    },

    /**
     * Set data content into property of the working Node
     *
     * @param propertyName
     * @param value
     */
    setWorkingNodeDataProperty(propertyName, value) {
      this.workingNode.data[propertyName] = value
    },
    /**
     * Set working node for edit
     * @param nodeKey
     */
    setWorkingNodeData(nodeKey) {
      this.workingNode = structureTreeTableService.findParentNodeById(
        this.nodeTree,
        nodeKey,
      )
    },

    setWorkingNode(node) {
      this.workingNode = node
    },

    /**
     * Set all companies that belongs to tenant admin
     *
     * @param nodeTree
     * @param companyUsers
     * @param tooltipConfig
     * @param t i!8n instance
     */
    setNodeTreeData(nodeTree, companyUsers, tooltipConfig, t) {
      this.nodeTree = structureTreeTableService.updateNodeTreeWithResponsible(
        nodeTree,
        companyUsers,
      )
      this.nodeTree = structureTreeTableService.addTooltipsToNodes(
        this.nodeTree,
        tooltipConfig,
        t,
      )
    },

    /**
     * Set node info
     * @param nodeInfo
     */
    setNodeInfoData(nodeInfo) {
      this.nodeInfo = nodeInfo
    },
    /**
     * Set valid address flag
     * @param isValidAddress
     */
    setIsValidAddress(isValidAddress) {
      this.isValidAddress = isValidAddress
    },
    /**
     * Create a new empty business are working  node
     */
    newWorkingNode() {
      this.workingNode = structureTreeTableService.newNodeItem({
        name: null,
        nameLang: null,
        area: null,
        parent: null,
        responsible: null,
        active: true,
        type: null,
        operationType: null,
        businessAreas: null,
        mapbox: null,
        timezone: null,
        description: null,
      })
    },

    setValidationError(field, hasError) {
      this.validationErrors[field] = hasError
    },
  },
})
